module.exports = __webpack_public_path__ + "img/ico-swiper-btn-prev.2b3332a4.svg";